module.exports = __webpack_public_path__ + "img/close-circle.e68019f5.svg";